import './staffMemberManagement.scss';
import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import { ImageUtils } from '../../utils/image';
import { Card } from '../layout/card';
import { SplitPane } from '../layout/splitPane';
import { LazyCosmosImage } from '../media/cosmosImage';
import { StaffMemberSocials } from './staffMember';
export const StaffMemberManagement = ({ staffMember }) => (<Card className="staff-member-management">
    <SplitPane alternate left={<div className="management-team-member-info">
          <div>
            <LazyCosmosImage className="management-team-member-photo" alt={staffMember.name} ticket={staffMember.alt_photo_url[0].ticket} size={ImageUtils.imageSizes.squareVeryTiny}/>
          </div>

          {staffMember.bio && (<div className="team-member-info">
              <h3 className="m-bottom-small">
                <b>{staffMember.name}</b> {staffMember.position}
              </h3>

              {staffMember.bio && <ReactMarkdown source={staffMember.bio}/>}

              <StaffMemberSocials staffMember={staffMember}/>
            </div>)}
        </div>} rightProps={{ className: 'staff-member-illustration' }} right={<LazyCosmosImage alt={staffMember.name} ticket={staffMember.photo_url[0].ticket} size={ImageUtils.imageSizes.squareSmall}/>}/>
  </Card>);
